export default "__VITE_ASSET__nhMTEqIC__"